import React from "react";
import "./assest_design/Dashboard.css";

export default function Dashboard() {
  return (
    <div className="dashboard-page">

      {/* HEADER */}
      <section className="dashboard-header">
        <h1>Dashboard</h1>
        <p>
          Real-time visibility, performance insights, and decision intelligence
          across your systems.
        </p>
      </section>

      {/* METRICS */}
      <section className="dashboard-metrics">
        <div className="metric-card">
          <h3>Operational Visibility</h3>
          <p>
            Monitor users, assets, and activity across web and mobile platforms
            in real time.
          </p>
        </div>

        <div className="metric-card">
          <h3>Performance Insights</h3>
          <p>
            Track uptime, task completion, workforce efficiency, and
            system performance.
          </p>
        </div>

        <div className="metric-card">
          <h3>Data-Driven Decisions</h3>
          <p>
            Convert operational data into actionable insights that support
            planning and optimisation.
          </p>
        </div>
      </section>

      {/* USE CASES */}
      <section className="dashboard-usecases">
        <h2>What you can see</h2>

        <ul>
          <li>✔ Workforce movement & attendance</li>
          <li>✔ Asset utilisation & downtime</li>
          <li>✔ AI model performance & accuracy</li>
          <li>✔ System reliability (online & offline)</li>
          <li>✔ Trends, alerts, and anomalies</li>
        </ul>
      </section>

    </div>
  );
}
